import { TasksBoardComponent } from "@/components/shared";
import { Task, FetchTasksByUserIdQuery, FetchTasksByUserIdQueryVariables, FetchTasksByUserIdDocument } from "@/graphql/__generated__/graphql";
import { useUserData } from "@/hooks/cache";
import { useQuery } from "@apollo/client/react";

function MyTasks() {
  const user = useUserData();

  const { data, loading } = useQuery<FetchTasksByUserIdQuery, FetchTasksByUserIdQueryVariables>(FetchTasksByUserIdDocument, {
    variables: {
      userId: user?.id ?? 0,
    },
    fetchPolicy: "cache-and-network",
  });

  const userTasks = data?.fetchTasksByUserId || [];

  return (
    <div className="w-full h-[calc(100vh-64px)] overflow-x-auto overflow-y-auto bg-slate-50">
      <div className="min-w-[800px] h-full">
        <TasksBoardComponent className="pl-4" tasks={userTasks as Task[]} type="user" loading={loading} />
      </div>
    </div>
  );
}

export default MyTasks;
